import screenerSessionResults from '../constants/screener-session-result';

export const validateScreenerAnswers = (answers, questionOptions) => {
  let qualifyCount = 0;
  let maySelectCount = 0;
  let disqualifyCount = 0;

  // answers options count to qualify or disqualify the tester
  answers.forEach((answerId) => {
    const questionOption = questionOptions.find((option) => option.id === answerId);
    if (questionOption) {
      if (questionOption.qualify) {
        qualifyCount += 1;
      }
      if (!questionOption.qualify && !questionOption.disqualify) {
        maySelectCount += 1;
      }
      if (questionOption.disqualify) {
        disqualifyCount += 1;
      }
    }
  });

  // one disqualify answer is enough to disqualify the tester
  if (disqualifyCount > 0) {
    return screenerSessionResults.DISQUALIFIED;
  }

  // none disqualify answer and at least one qualify answer is enough to qualify the tester
  if (qualifyCount >= 1 && disqualifyCount === 0) {
    return screenerSessionResults.QUALIFIED;
  }

  // cases when multiple_selects with may_select option is selected without any qualify or disqualify option
  if (qualifyCount === 0 && maySelectCount >= 1 && disqualifyCount === 0) {
    // check at least one may_select, but the question has qualify and disqualify options
    if (questionOptions.some((option) => option.qualify) && questionOptions.some((option) => option.disqualify)) {
      return screenerSessionResults.DISQUALIFIED;
    }
    // check at least one may_select, but the question has no disqualify option
    if (questionOptions.some((option) => option.qualify) && questionOptions.some((option) => !option.disqualify)) {
      return screenerSessionResults.DISQUALIFIED;
    }
    // check at least one may_select, but the question has no qualify option
    if (questionOptions.some((option) => !option.qualify) && questionOptions.some((option) => option.disqualify)) {
      return screenerSessionResults.QUALIFIED;
    }
    // case when question has only may_select options
    if (questionOptions.some((option) => !option.qualify) && questionOptions.some((option) => !option.disqualify)) {
      return screenerSessionResults.QUALIFIED;
    }
  }
  return screenerSessionResults.DISQUALIFIED;
};
